import type { SceneStoreGetState, SceneStoreSetState } from "../sceneStore.types";
import type { BodyActions } from "./actionTypes";
import { createBodyAttachmentActions } from "./bodyAttachmentActions";
import { createBodyFieldActions } from "./bodyFieldActions";
import { createBodyHierarchyActions } from "./bodyHierarchyActions";
import { createBodyMeshActions } from "./bodyMeshActions";
import { createBodyRemovalActions } from "./bodyRemovalActions";
import { createBodySetActions } from "./bodySetActions";

export const createBodyActions = (
  set: SceneStoreSetState,
  get: SceneStoreGetState
): BodyActions => ({
  ...createBodySetActions(set),
  ...createBodyRemovalActions(set),
  ...createBodyFieldActions(set, get),
  ...createBodyMeshActions(set),
  ...createBodyHierarchyActions(set, get),
  ...createBodyAttachmentActions(set, get),
});
